var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 17.243 18",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_calendar_FILL1_wght500_GRAD0_opsz48",
    d: "M7.13,20.775a1.474,1.474,0,0,1-1.43-1.43V6.392a1.36,1.36,0,0,1,.431-1.009,1.387,1.387,0,0,1,1-.421H8.455V4.415a.672.672,0,0,1,.221-.5A.7.7,0,0,1,9.17,3.7a.713.713,0,0,1,.526.21.688.688,0,0,1,.21.5v.547h6.981V4.415A.718.718,0,0,1,17.6,3.7a.713.713,0,0,1,.526.21.688.688,0,0,1,.21.5v.547h1.325a1.436,1.436,0,0,1,1.43,1.43v6.371h-1.43V10.345H7.13v9H13.8v1.43Zm15.014-4.542-1.619-1.619.61-.61a.768.768,0,0,1,1.009,0l.61.61a.742.742,0,0,1,.189.515.668.668,0,0,1-.189.494Zm-7.086,5.11v-.967a.652.652,0,0,1,.053-.252,1,1,0,0,1,.158-.252l4.353-4.353,1.619,1.619L16.887,21.49a.69.69,0,0,1-.242.168.766.766,0,0,1-.263.042h-.967a.359.359,0,0,1-.357-.357Z",
    transform: "translate(-5.7 -3.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingIcon);
export default __webpack_public_path__ + "static/media/scheduling_icon.ce27faaacb4ccc539e471648af313b96.svg";
export { ForwardRef as ReactComponent };